export function parseEnvArray (array?: string): string[] {
  if(!array) return undefined;
  const parsed = array.split(',');
  if(!parsed.length) return undefined;
  return parsed.map((item) => item.trim().toLowerCase());
}
